import React from "react";
import { Typography, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TopOfAddStepTables from "../../CellStepManagement/components/TopOfAddStepTables";
import External from "../../CellStepManagement/components/External";
import ExternalTable from "../../CellStepManagement/components/ExternalTable";
import PaginationBlock from "./PaginationBlock";
import Divider from "@mui/material/Divider";

const StepTypeExternal = ({
  newItem,
  toggleItem,
  url,
  param,
  name,
  onChange,
  onParamChange,
  onNameChange,
  handleClick,
  id,
  studyId,
  stepType,
  data,
  loading,
  rowsPerPage,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  searchTerm,
  onSearch,
  hasSearched,
  setHasSearched,
  resetStateToLoading,
  onSelectItem,
  resultCount,
  onDone,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ padding: "4px 0 12px", width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              minWidth: 220,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography variant="subtitle1" style={{ lineHeight: 1.2 }}>
              Add a new external step
            </Typography>

            <Typography
              variant="caption"
              color="textSecondary"
              style={{
                marginTop: 2,
                lineHeight: 1.2,
              }}
            >
              An external step is a redirection within the study to a website
              outside of Lumen&apos;s domain (e.g. a study platform like Alchemer)
            </Typography>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginLeft: "auto",
            }}
          >
            <div style={{ width: 420 }}>
              <TopOfAddStepTables
                button
                buttonText="External Step"
                buttonClass="button-primary"
                buttonClick={toggleItem}
                textFieldLabel="Search external steps"
                textFieldChange={(term) => {
                  onSearch(term);
                  if (term.length > 2) {
                    setHasSearched(true);
                    resetStateToLoading();
                    onSelectItem(stepType, studyId, term, rowsPerPage, currentPage);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Paper
        elevation={0}
        square
        style={{
          padding: 0,
          borderRadius: 0,
          marginBottom: 24,
          background: "transparent",
        }}
      >
        {!newItem ? (
          <>
            <Divider
              sx={{
                borderColor: "rgba(0,0,0,0.08)",
              }}
            />

            {!hasSearched ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "64px 0",
                  color: "#888",
                  fontSize: "14px",
                }}
              >
                <SearchIcon style={{ fontSize: 50, marginBottom: 20 }} />
                <span>Search for an External step</span>
              </div>
            ) : (
              <>
                <ExternalTable
                  onAddAll={(selectedIds) => {
                    selectedIds.forEach((extId) =>
                      handleClick(id, stepType, studyId, extId, {
                        closeAfter: false,
                      })
                    );
                    onDone?.();
                  }}
                  loading={loading}
                  data={data}
                />

                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 2,
                    background: "#fff",
                    padding: "8px 0",
                    borderTop: "1px solid rgba(0,0,0,0.08)",
                  }}
                >
                  <PaginationBlock
                    resultCount={resultCount}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <External
            title="Add external step"
            addEmbeddedStep={() => handleClick(id, stepType, studyId)}
            toggleItem={toggleItem}
            showParamInput={true}
            value={url}
            onChange={onChange}
            onParamChange={onParamChange}
            onNameChange={onNameChange}
          />
        )}
      </Paper>
    </div>
  );
};

export default StepTypeExternal;